import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
const About = () => {
  return <div className="min-h-screen bg-background">
      <main className="container mx-auto px-4 py-16">
        <div className="max-w-3xl mx-auto">
          <Link to="/">
            <Button variant="ghost" className="mb-6">← Back to Home</Button>
          </Link>
          
          <h1 className="text-3xl font-bold mb-8">About The Safelight Project</h1>
          
          <div className="space-y-6 text-film-600">
            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Our Mission</h2>
              <p>Safelight is a global community resource for film photographers who travel. Our mission is to make traveling with film easier and safer by providing reliable information about airport security processes worldwide.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">What We Do</h2>
              <p>We collect and share real experiences from film photographers about their airport security encounters. Through user reviews and ratings, we help you:</p>
              <ul className="list-disc pl-6 space-y-2 mt-2">
                <li>Find airports where hand-checking film is routine</li>
                <li>Prepare for airports where X-ray scanning is mandatory</li>
                <li>Learn from other photographers' experiences</li>
                <li>Share your own experiences to help fellow film photographers</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Our Community</h2>
              <p>Safelight is powered by a global community of analog photographers who contribute their experiences and knowledge. Every review helps build a more comprehensive database of airport practices regarding film.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Why "Safelight"?</h2>
              <p>In darkroom photography, a safelight is a special light that allows photographers to work without exposing their sensitive materials. Like that protective illumination, our platform helps shield your precious film from potential damage during travel.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3 text-foreground">Join Us</h2>
              <p>Whether you're a professional photographer or an enthusiastic hobbyist, your experiences matter. Sign up today to contribute to our database and help fellow film photographers travel with confidence.</p>
            </section>
          </div>
        </div>
      </main>
    </div>;
};
export default About;